import { useNavigate } from "react-router-dom";

import { PageTitle, PageLayout, ContentContainer } from "components/layout";
import { toast } from "components/ui/use-toast";

import { useCreateRegionalSubstitutionMutation } from "@/services/regional-substitution";
import { SubstitutionForm } from "../components/substitution-form";
import { RegionalSubstitutionFormData } from "../validations/regional-substitution.validation";
import { REGIONAL_SUBSTITUTION_MESSAGES } from "../constants/messages";
import { REGIONAL_SUBSTITUTION_ROUTES } from "../constants/routes";
import { toIsoEndOfDay, toIsoStartOfDay } from "@/utils/date-vigencia";
import { extractRtkErrorMessage } from "@/utils/extract-rtk-error";
import { isConflictError } from "@/utils/error-mapper";

export const CreateRegionalSubstitution: React.FC = () => {
  const navigate = useNavigate();
  const [createRegionalSubstitution, { isLoading }] =
    useCreateRegionalSubstitutionMutation();

  const goToList = () => navigate(REGIONAL_SUBSTITUTION_ROUTES.LIST);

  const handleSubmit = async (data: RegionalSubstitutionFormData) => {
    try {
      await createRegionalSubstitution({
        user_id: data.user_id,
        regional_id: data.regional_id,
        initial_term: toIsoStartOfDay(data.initial_term),
        final_term: toIsoEndOfDay(data.final_term),
      }).unwrap();
      toast(REGIONAL_SUBSTITUTION_MESSAGES.CREATE.SUCCESS);
      goToList();
    } catch (error) {
      if (isConflictError(error)) {
        toast(REGIONAL_SUBSTITUTION_MESSAGES.CREATE.CONFLICT);
        return;
      }
      const apiMessage = extractRtkErrorMessage(
        error,
        REGIONAL_SUBSTITUTION_MESSAGES.CREATE.ERROR.description,
      );
      toast({
        ...REGIONAL_SUBSTITUTION_MESSAGES.CREATE.ERROR,
        description: apiMessage,
      });
    }
  };

  return (
    <PageLayout>
      <PageTitle
        title="Novo Vínculo de Substituição"
        description="Designe um Gerente para substituir um Regional por um período"
      />
      <ContentContainer>
        <SubstitutionForm
          defaultValues={{
            user_id: "",
            initial_term: "",
            final_term: "",
          }}
          peopleDisabled={false}
          submitting={isLoading}
          submitLabel="Salvar"
          onSubmit={handleSubmit}
          onCancel={goToList}
        />
      </ContentContainer>
    </PageLayout>
  );
};
